import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import VideoPlayer from "../../../shared/video/video_room/player/video_player";
import classNames from "classnames";
import Select from "react-select";
import {Controller} from "react-hook-form";
import IframeResizer from "iframe-resizer-react";

const RenderedRegistrationPage = ({registrationPageId, isPublic}) => {
  const registrationPages = useSelector(state => state.registrationPages)
  const tagOwner = useSelector(state => state.tagOwner)
  const registrationPage = registrationPages?.find(rp => rp.id === registrationPageId)

  if (!registrationPage) {
    return <div className={"alert alert-danger"}>
      Registration Page not found!
    </div>
  }

  let url = `/registration_pages/${registrationPage.id}`

  if (!isPublic) {
    if (!tagOwner) {
      return <div className={"alert alert-danger"}>
        Tag owner not found!
      </div>
    }

    url = `/registration_pages/${registrationPage.id}/${tagOwner.id}`
  }

  return <IframeResizer
      src={url}
      style={{width:"100%"}}
      frameBorder="0"
      scrolling="no"
      allow="autoplay"
      allowFullScreen
  />
}

const RegistrationPageCellPlugin = {
  Renderer: (props) => {
    const {registration_page_id, is_public} = props.data

    return <RenderedRegistrationPage
        registrationPageId={registration_page_id}
        isPublic={is_public}
    />
  },

  id: 'registration-page-cell-plugin',
  title: 'Registration Page',
  description: 'Add a registration page',
  version: 1,
  allowClickInside: true,
  toolbar_element: document.createElement('div'),
  controls: {
    type: 'custom',
    allowClickInside: true,
    Component: (props) => {
      const registrationPages = useSelector(state => state.registrationPages)
      const options = registrationPages.map(registrationPage => ({value: registrationPage.id, label: registrationPage.title}))

      console.log("REGPAGE COMP", props)

      return <>
        <div className="form-group">
          <label>Registration Page</label>
          <Select
              defaultValue={options.find(o => o.value === props.data.registration_page_id)}
              options={options}
              menuPortalTarget={document.body}
              styles={{menuPortal: base => ({...base, zIndex: 9999})}}
              onChange={val => props.onChange({...props.data, registration_page_id: val.value})}
          />
        </div>
        <div className="form-group form-check">
          <input
              type="checkbox"
              className="form-check-input"
              id={`is_public_reg_page_checkbox_${props.nodeId}`}
              defaultChecked={props.data.is_public}
              value={props.data.is_public}
              onChange={(e) => props.onChange({...props.data, is_public: e.target.checked})}
          />
          <label className="form-check-label" htmlFor={`is_public_reg_page_checkbox_${props.nodeId}`}>Use Public</label>
        </div>
      </>
    },
  },
}

export default RegistrationPageCellPlugin